export enum WebsiteLoginModeEnum {
  Login = 'websiteLogin',
  Registration = 'websiteRegistration',
  ConfirmRegistration = 'websiteConfirmRegistration',
  Request = 'websiteRequest',
  Reset = 'websiteReset',
}

export const CHANGE_WEBSITE_LOGIN_MODE = 'CHANGE_WEBSITE_LOGIN_MODE'

export type ChangeWebsiteLoginMode = {
  type: typeof CHANGE_WEBSITE_LOGIN_MODE
  payload: WebsiteLoginModeEnum
}
